import { object, string } from 'yup';

import { getMaxLengthErrMsg } from '@constants/validationConstants';
import { MAX_DESCRIPTION_LENGTH } from '@constants/validationMessages';

export const descriptionSchema = object({
	description: string()
		.trim()
		.nullable()
		.max(MAX_DESCRIPTION_LENGTH, getMaxLengthErrMsg('Description', MAX_DESCRIPTION_LENGTH)),
});
